import { snakeCaseKeys } from '@base/utils';

export const buildTrackingSearchRequest = (payload) => {
  const { filters, pagination } = payload;
  if (filters && filters.startDate && !filters.endDate) filters.endDate = filters.startDate;
  const params = { ...pagination, ...filters };
  return snakeCaseKeys(params);
};
